<template>
<div class="row" v-loading="loading">
  <div class="col-md-12">
    <card :title="title" v-if="modelSchema">
      <fg-input  :error="errorMessages.name" :max-length="modelSchema.name.maxLength" :required="modelSchema.name.required" v-model="model.name" :placeholder="'Name' | translate" :label="'Name' | translate"></fg-input>


      <tabs v-model="activeEditor">
        <tab-pane :title="'Editor' | translate" key="editor">
          <SchemaEditor v-model="model.schema" @change="updateSchemaJSON" ref="schemaEditor"></SchemaEditor>
        </tab-pane>
        <tab-pane :title="'JSON Schema' | translate" key="code">
          <MonacoEditor v-if="model.schema"
                        ref="jsonEditor"
                        v-model="schemaJson"
                        theme="vs-dark"
                        language="json"
                        height="500"
                        @change="monacoChanged"
                        :options="monacoOptions"
                        :editor-mounted="editorMounted"
          ></MonacoEditor>
        </tab-pane>
        <tab-pane :title="'Localization' | translate" key="locale">
          <locale-editor v-if="activeEditor === 'locale'" :schema="model.schema"></locale-editor>
        </tab-pane>
      </tabs>

      <p-button type="info" round @click="save">
        <translate key="add" v-if="!isNew">Save</translate>
        <translate key="save" v-else>Add</translate>
      </p-button>
      <p-button type="info" round @click="saveAndClose">
        <translate key="add" v-if="!isNew">Save and close</translate>
        <translate key="save" v-else>Add and close</translate>
      </p-button>

    </card> <!-- end card -->
  </div> <!--  end col-md-6  -->
</div>
</template>

<script>
  import _ from 'lodash'
  import { Tabs, TabPane, Card } from 'src/components/UIComponents'
  import moment from 'moment'
  import {Select, Option, OptionGroup, DatePicker, TimePicker} from 'element-ui'
  import SchemaEditor from '../../UIComponents/SchemaEditor'
  import LocaleEditor from '../../UIComponents/LocaleEditor'

  import MonacoEditor from 'monaco-editor-vue';

  export default {
    breadcrumb () {
      return {
        label: this.title,
        parent: {
          name: 'manage-surveys'
        }
      }
    },
    components: {
      Card,
      LocaleEditor,
      [DatePicker.name]: DatePicker,
      [TimePicker.name]: TimePicker,
      [Select.name]: Select,
      [OptionGroup.name]: OptionGroup,
      [Option.name]: Option,
      Tabs,
      TabPane,
      MonacoEditor,
      SchemaEditor
    },
    props: {
      baseApi: {
        type: String,
        description: 'Remote API base URL',
        default: () => 'survey/surveys/'
      }
    },
    name: 'SurveyForm',
    beforeRouteEnter: (to, from, next) => {
      next(vm => {
        if (to.params.id) {
          vm.loadRecord(to.params.id)
        }
      })
    },
    beforeRouteUpdate: (to, from, next) => {
      next(vm => {
        if (to.params.id) {
          vm.loadRecord(to.params.id)
        }
      })
    },
    computed: {
      title () {
        if (this.isNew) {
          return this.$gettext('Add survey')
        } else {
          return this.$gettext('Edit survey')
        }
      },
      isNew () {
        return this.model.id === null
      },
    },
    created () {
      this.getSchema()

    },
    mounted () {
      if (this.$route.params.id && !this.model.id) {
        this.loadRecord(this.$route.params.id)
      }
    },
    data () {
      return {
        activeEditor: null,
        monacoOptions: {
          autoIndent: true
        },
        schemaJson: null,
        loading: false,
        errorMessages: {},
        schema: null,
        modelSchema: null,
        model: {
          id: null,
          name: null,
          schema: {
            $schema: "http://json-schema.org/draft-04/schema#",
            type: "object",
            title: "Пожалуйста, ответьте на вопросы",
            properties: {},
            additionalProperties: false,
            required: []
          },
          options: {}
        }
      }
    },
    methods: {
      updateSchemaJSON () {
        this.schemaJson = JSON.stringify(this.model.schema)
        this.$nextTick(() => {
          if (this.$refs.jsonEditor) this.$refs.jsonEditor.editor.getAction('editor.action.formatDocument').run();
        })
      },
      updateModel (model) {
        this.model = model
        this.updateSchemaJSON()
      },
      prepareModelToSave() {
        if (this.$refs.schemaEditor) {
          this.$refs.schemaEditor.getSchema()
        }
        let model = _.cloneDeep(this.model)
        return model
      },
      async loadRecord (id) {
        this.loading = true
        const result = await this.$http.get(`${this.$props.baseApi}${id}/`)
        this.updateModel(result.data)
        this.loading = false
        return result.data
      },
      async getSchema () {
        let url = this.$props.baseApi
        const result = await this.$http.options(url)
        this.schema = result.data
        this.modelSchema = this.schema.actions.POST
      },
      async save () {
        this.loading = true
        const modelToSave = this.prepareModelToSave()
        const request = this.isNew ? this.$http.post(this.$props.baseApi, modelToSave) : this.$http.put(`${this.$props.baseApi}${this.model.id}/`, modelToSave)
        try {
          const result = await request
          this.updateModel(result.data)
          this.loading = false
          this.errorMessages = {}
          return true
        } catch (error) {
          this.loading = false
          this.errorMessages = _.mapValues(error.response.data, x => x instanceof Array ? x.join(', ') : x)
          return false
        }
      },
      async saveAndClose () {
        if (await this.save()) {
          this.$router.go(-1)
        }
      },
      editorMounted (editor, monaco) {
        editor.getAction('editor.action.formatDocument').run()
        // debugger
      },
      monacoChanged (newValue, event) {
        try {
          this.model.schema = JSON.parse(newValue)
        } catch (e) {
          console.error(`Не удалось распарсить новые данные`)
        }
      }
    },
    watch: {
      activeEditor (newValue) {
        switch (newValue) {
          case 'code':
            this.updateSchemaJSON()
            this.$nextTick(() => {
              this.$refs.jsonEditor.editor.layout()
              this.$refs.jsonEditor.editor.getAction('editor.action.formatDocument').run()
            })
            break
        }
      }
    }
  }
</script>

<style scoped>

</style>
